import React from "react";
import GridPlayMain from "../puzzles/grid/GridPlayMain";

/**
 * Word-search grid play under `/story/play-grid/word_search/:id` (same UX as puzzle route).
 */
export default function StoryWordSearchPlay() {
    return <GridPlayMain gridPlayRouteTypeSegment="word_search" storyPlayLayout />;
}
